import { IBoleta } from './../models/iBoleta';
import { Injectable } from '@angular/core';
import { ROUTE_COMERCIAL } from '../constants/constant.model';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BoletaService {

  constructor(private apiService: ApiService,
    private http: HttpClient) {
  }

  insertarBoleta(data: IBoleta): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta);
    return this.apiService.executePostJson(data).pipe();
  }

  insertarBoletaPuntodeventaV2(data: IBoleta): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta+'/v2');
    return this.apiService.executePostJson(data).pipe();
  }


  actualizarBoleta(data: IBoleta): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta);
    return this.apiService.executePutJson(data).pipe();
  }

  obtenerBoleta(numint: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta);
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  calcularBoleta(data: IBoleta): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.calcularBoleta);
    return this.apiService.executePutJson(data).pipe();
  }

  buscarBoleta(situac: string, codsuc: number, codcli: string, fdesde: string, fhasta: string, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta + '/buscar');
    return this.apiService.execGetQueryJson(`?situac=${situac}&codsuc=${codsuc}&codcli=${codcli}&fdesde=${fdesde}&fhasta=${fhasta}&limit=${limit}&offset=${offset}`).pipe();
  }

  buscarBoletasParaGuias(femisi: any, moneda: string, codsuc: number, codcli: string): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta + '/buscar/boletas-para-guias');
    return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
  }

  buscarBoletasParaDevolucion(femisi: any, moneda: string, codsuc: number, codcli: string): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudBoleta + '/buscar/boletas-para-devolucion');
    return this.apiService.execGetQueryJson(`?femisi=${femisi}&moneda=${moneda}&codsuc=${codsuc}&codcli=${codcli}`).pipe();
  }


  public anular(numint: number, coduser: string) {
    return this.http.put(environment.serviceUrl + "boleta/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
  }

  public eliminar(numint: number, coduser: string) {
    return this.http.put(environment.serviceUrl + "boleta/" + numint + "/eliminar?coduser=" + coduser, null, { observe: 'response' },)
  }

  download_pdf(_formato: number, numint: number, cia: string) {
    let fullUrl: any = null;
    if (_formato == 1) //A4
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-a4.pdf?` + "cia=" + cia;
    if (_formato == 2) //ticket
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-ticket.pdf?` + "cia=" + cia;
    if (_formato == 3) //defecto
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-default.pdf?` + "cia=" + cia;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }
  download_pdfAgrup(_formato: number, numint: number, cia: string,agrupado:any) {
    let fullUrl: any = null;
    if (_formato == 1)
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-1.pdf?` + "cia=" + cia+ `&agrupado=${agrupado}`;
    if (_formato == 2)
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-ticket.pdf?` + "cia=" + cia+ `&agrupado=${agrupado}`;
    if (_formato == 3)
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-default.pdf?` + "cia=" + cia+ `&agrupado=${agrupado}`;

    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }

  download_pdf_cargo( numint: number, cia: string) {
    let fullUrl: any = null;
      fullUrl = environment.serviceUrl_Report + `boleta/${numint}/report/public/format-cargo-rel-guias-remision.pdf?` + "cia=" + cia;
    const httpOptions = {
      'responseType': 'arraybuffer' as 'json'
    };
    return this.http.get(fullUrl, httpOptions);
  }


}
